import { render, staticRenderFns } from "./Abonos.vue?vue&type=template&id=040cd52a"
import script from "./Abonos.vue?vue&type=script&lang=js"
export * from "./Abonos.vue?vue&type=script&lang=js"
import style0 from "./Abonos.vue?vue&type=style&index=0&id=040cd52a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports